import { logDOM } from "@testing-library/react"
import { SPREAD_CONSTANTS } from './const';

/* eslint-disable no-control-regex */
const LS_TOKEN = 'token'
const LS_EMAIL = 'email'
const LS_NAME = 'name'
const LS_BUSINESS_NAME = 'businessName'

export const getAuthToken = () => window.localStorage.getItem(LS_TOKEN)

export const setAuth = ({ is_user_admin,token, email, name, businessName }) => {
  window.localStorage.setItem(LS_TOKEN, token)
  window.localStorage.setItem(LS_EMAIL, email)
  window.localStorage.setItem(LS_NAME, name)
  window.localStorage.setItem(LS_BUSINESS_NAME, businessName)
  setCookie('isUserAdmin', is_user_admin ? 'true' : 'false');  
}

export const removeAuth = () => {
  window.localStorage.removeItem(LS_TOKEN)
  window.localStorage.removeItem(LS_EMAIL)
  window.localStorage.removeItem(LS_NAME)
  window.localStorage.removeItem(LS_BUSINESS_NAME)
  deleteCookie('isUserAdmin')
}

// cookie-utils.js
const setCookie = (name, value) => {
  // 365 days in milliseconds
  const oneYearMs = 365 * 24 * 60 * 60 * 1000;
  const expires = new Date(Date.now() + oneYearMs).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/;`;
};

export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(^| )'+name+'=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export const capitalizeFirstLetter = (string) => string[0].toUpperCase() + string.slice(1)

export const isFunction = (func) => typeof func === 'function'

// eslint-disable-next-line no-confusing-arrow
export const addOrRemove = (arr, item) =>
  arr.includes(item) ? arr.filter((i) => i !== item) : [...arr, item]

export const toArray = (value) => {
  if (!value) return []
  return typeof value === 'string' ? [value] : value
}

export const formatPhoneNumber = (value) => {
  if (!value) return '';
  const cleaned = value.replace(/\D/g, ''); // Remove non-digit characters
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return value;
};

export const getFilterLabel = (arr, currentValue) =>
  arr.find((filter) => filter.value === currentValue).label

const formatPrice = (value) => Number(value)?.toFixed(2) ?? 0
export const dollarTemplate = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(formatPrice(value))

export const apiErrorMessage = (error) => {
  if (typeof error?.response?.data?.error?.user_message === 'object') {
    return error?.response?.data?.error?.user_message?.message
  }
  if (error?.response?.data?.error?.user_message) {
    return toArray(error?.response?.data?.error?.user_message)?.join('. ')
  }
  if (error?.response?.data?.errors) {
    return toArray(error?.response?.data?.errors)?.join('. ')
  }
  return 'Oops! Something went wrong!'
}

export const formatAddress = (attributes) => [attributes.street, attributes.street2, attributes.city, attributes.stateProvince, attributes.zip].filter(Boolean) .join(', ');

export const isEmail = (email) =>
  /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(
    email,
  )

export const getFileNameFromUrl = (url) => {
  const fileName = url?.split('/')

  return fileName[fileName.length - 1].split('?')[0]
}

export const copyToClipboard = (textToCopy) => navigator.clipboard.writeText(textToCopy ?? '')

export const toTitleCase = (phrase) =>
  phrase
    .replace(/_/g, ' ')
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

export const splitRecipientName = (recipient) => {
  const trimmedRecipient = (recipient || '').trim();
  if (!trimmedRecipient) {
    return { firstName: '', lastName: '' };
  }
  
  const nameParts = trimmedRecipient.split(/\s+/);
  
  if (nameParts.length === 1) {
    return { firstName: nameParts[0], lastName: '' };
  }

  const lastName = nameParts[nameParts.length - 1];
  const firstName = nameParts.slice(0, -1).join(' ');
  
  return { firstName, lastName };
};

export const combineRecipientName = (firstName, lastName) => {
  return `${firstName || ''} ${lastName || ''}`.trim();
};

export const formatCanvasPrintDetails = (paper, printSize) => {
  // Parse canvas format: "Canvas - White Wrap - 0.75 inch bar"
  const canvasMatch = paper.match(/^Canvas\s*-\s*(.+?)\s*-\s*(.+)$/i);
  if (canvasMatch) {
    const wrapType = canvasMatch[1]; 
    const barSize = canvasMatch[2]; 
    return `Canvas - ${printSize} - ${wrapType} - ${barSize}`;
  }
  // Fallback if regex doesn't match
  return `${paper} ${printSize}`;
};

export const getLineItemThumbnailUrl = (lineItem) => {
  const firstPhoto = lineItem?.photographs?.[0];
  return (
    lineItem?.photographCroppedUrl ||
    lineItem?.photographUrl ||
    firstPhoto?.photographCroppedUrl ||
    firstPhoto?.photographUrl ||
    null
  );
};

export const getLineItemPhotoLabel = (lineItem) => {
  if (lineItem?.photoFileName) return lineItem.photoFileName;
  const photographs = lineItem?.photographs;
  if (!photographs?.length) return '';
  return photographs.length > 1
    ? `${photographs[0]?.photoFileName} +${photographs.length - 1} more`
    : photographs[0]?.photoFileName ?? '';
};

export const getFinishTypeLabel = (lineItem) => {
  if (lineItem?.photographType === 'test-prints') return 'TEST PRINTS';
  if (lineItem?.photographType === 'artist-proofs') return 'ARTIST PROOF';

  const finishingCategory = lineItem?.finishingService?.finishingCategory;
  return finishingCategory ? toTitleCase(finishingCategory) : 'none';
};

export const getLineItemMatDetails = (lineItem) => {
  const { matType, openingShape } = lineItem?.frameMat || {};
  if (matType === 'no-mat') return [];

  const matTypeLabels = {
    '4-ply': '4-Ply',
    '8-ply': '8-Ply',
    'double-mat-4-ply': 'Double Mat 4-Ply',
  };

  return [
    matType && `${matTypeLabels[matType] || matType}`,
    openingShape && `${toTitleCase(openingShape)}`,
  ].filter(Boolean);
};

const MULTI_OPENING_FINISH_REGEX = /\s*(mat\s*\/\s*fr?ame)\s*$/i;

export const splitMultiOpeningPrintSizeName = (name) => {
  const match = name?.match(MULTI_OPENING_FINISH_REGEX);
  if (!match) return { size: name?.trim() || '', finishType: '' };
  return { size: name.slice(0, match.index).trim(), finishType: match[1] };
};

export const generateSpreadOptions = (maxSpreads = SPREAD_CONSTANTS.DEFAULT_MAX_SPREADS) => {
  const count = maxSpreads - SPREAD_CONSTANTS.MIN_SPREADS + 1;
  return Array.from({ length: count }, (_, i) => {
    const value = String(i + SPREAD_CONSTANTS.MIN_SPREADS);
    return { value, text: value };
  });
};

export const getMaxSpreadsForPaperType = (paperTypeText) => {
  if (paperTypeText.includes('hemp')) {
    return SPREAD_CONSTANTS.HEMP_MAX_SPREADS;
  }
  return SPREAD_CONSTANTS.DEFAULT_MAX_SPREADS;
};

export const filterPhotosByProductType = (photos, productType) => {
  if (productType === 'default') {
    return photos.filter((photo) => photo.attributes?.productType !== 'albums')
  }

  const matchesType = (photo) => photo.attributes?.productType === productType
  if (productType === 'albums') {
    return photos.filter(
      (photo) =>
        matchesType(photo) && photo.attributes?.isAddedToCart === false,
    )
  }

  return photos.filter(matchesType)
}

export const filterAlbumProductTypePhotosForLineItem = (photos) =>
  (Array.isArray(photos) ? photos : []).filter(
    (photo) => photo.attributes?.productType === 'albums' && photo.attributes?.isAddedToCart === false,
  );

export const getAlbumLineItemPhotoValidationError = (orderedPhotos, isUpdate = false) => {
  const albumPhotoList = filterAlbumProductTypePhotosForLineItem(orderedPhotos);
  if (albumPhotoList.length < 10) {
    return isUpdate
      ? 'To update this item, please upload at least 10 spreads.'
      : 'To add this item to your cart, please upload at least 10 spreads.';
  }
  return undefined;
};

export const getAlbumSpreadError = (albumItems, albumForm) => {
  const currentFiles = albumItems?.length ?? 0;
  const currentSpreads = parseInt(albumForm?.inputs?.numberOfSpreads?.selectedValue, 10) || 10;

  const paperText = (albumForm?.inputs?.albumPaper?.selectedValueText || '').toLowerCase();

    if (paperText) {
    const maxSpreads = getMaxSpreadsForPaperType(paperText);
    const paperName = albumForm?.inputs?.albumPaper?.selectedValueText;

    if (currentFiles > maxSpreads) {
      const excess = currentFiles - maxSpreads;
      return `${paperName} supports a maximum of ${maxSpreads} spreads. You currently have ${currentFiles} spreads uploaded, please remove ${excess} spreads to continue.`;
    }

    if (currentSpreads > maxSpreads) {
      return `${paperName} supports a maximum of ${maxSpreads} spreads. Please reduce your spread count.`;
    }
  }
 
  if (currentFiles === 0) return undefined;

  if (currentSpreads > currentFiles) {
    return `To add another spread, please upload another photo. You currently have ${currentFiles} photos.`;
  }
  
  if (currentSpreads !== currentFiles) {
    return `The number of spreads must match the number of uploaded photos. You currently have ${currentFiles} photos and spreads ${currentSpreads}.`;
  }


  
  return undefined;
};

export const getDisplayNumber = (index) => index + 1;

export const getImageId = (image, index) => {
  if (!image) return null;
  return image.attributes?.guid || `image-${index}`;
};

export const getImageUrl = (image) => image?.attributes?.presignedPhotoUrl || image?.attributes?.smallestPhoto || '';

export const isMultiOpeningPrintSizeName = (name) => /mat\s*\/\s*fr?ame/i.test(name || '');

export const filterOutMultiOpeningPrintSizes = (printSizes, getName = (printSize) => printSize?.name) =>
  (printSizes || []).filter((printSize) => !isMultiOpeningPrintSizeName(getName(printSize)));

const SPECIAL_PRINT_SIZE_PRODUCT_TYPES = ['artist_proofs', 'test_prints'];

export const filterOutSpecialProductPrintSizes = (printSizes) =>
  (printSizes || []).filter(
    (printSize) => !SPECIAL_PRINT_SIZE_PRODUCT_TYPES.includes(printSize?.productType),
  );

export const getEmptyStateMessage = (productType) => {
  switch (productType) {
    case 'albums':
      return 'Choose Album Type in the sidebar to add photos to your order.';
    case 'test-prints':
      return 'Upload at least one photo to continue with your test print order.';
    case 'multi-opening':
      return "Please add photos to your order";
    default:
      return 'Choose Product Type above to add photos to your order.';
  }
};
